<template>
  <div
    v-loading.fullscreen.lock="fullScreenLoading"
    element-loading-text="loading..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <el-card shadow="always">
      <edit-form ref="editForm" />
    </el-card>
    <el-card shadow="always" class="mt-2">
      <div class="side-frame-danger">
        <span class="side-frame-text">收发货地址</span>
      </div>
      <order-point ref="pickupForm" :code="code" />
      <point-receiving ref="receivingForm" :code="code" />
    </el-card>
    <el-card shadow="always" class="mt-2">
      <order-goods ref="goodsForm" :code="code" />
    </el-card>
    <el-card shadow="always" class="mt-2" v-if="orderPackingDisabled">
      <order-packing ref="packingForm" />
    </el-card>
    <el-card shadow="always" class="mt-2" v-if="contractVisible">
      <div class="side-frame-success">
        <span class="side-frame-text">订单收入</span>
      </div>
      <order-income ref="incomeForm" :code="code" />
    </el-card>

    <div class="d-flex justify-content-end mt-2 mb-2">
      <el-button type="primary" size="small" @click="save('T')"
        >保存并提交调度</el-button
      >
      <el-button type="primary" size="small" @click="save('N')"
        >仅保存订单</el-button
      >
    </div>
    <el-dialog
      append-to-body
      title="提示信息"
      :visible.sync="dialogVisible"
      v-el-dialog-drag
      width="30%"
    >
      <span>订单创建成功，是继续创建订单，还是关闭当前功能？</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="closeCurPage()" size="small"
          >关闭当前功能</el-button
        >
        <el-button type="primary" size="small" @click="builderNextOrder()"
          >继续创建订单</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { mapActions } from "vuex"
import EditForm from "../builderOrder/components/index"
import OrderPoint from "../builderOrder/components/order-point"
import PointReceiving from "../builderOrder/components/order-point-receiving"
import OrderGoods from "../builderOrder/components/order-goods"
import OrderIncome from "../builderOrder/components/order-income"
import OrderPacking from "../builderOrder/components/order-packing"
export default {
  name: "carriage-builderOrder",
  components: {
    EditForm,
    OrderPoint,
    PointReceiving,
    OrderGoods,
    OrderIncome,
    OrderPacking,
  },
  data() {
    return {
      dialogVisible: false,
      code: "",
      disabled: false,
      fullScreenLoading: false,
      orderPackingDisabled: false,
      contractVisible: false,
    }
  },
  mounted() {
    this.querySysParams()
    this.querySysContractVisible()
  },
  methods: {
    ...mapActions("admin/page", ["close"]),
    async save(val) {
      // 获取订单主信息
      const getFormData = await this.$refs.editForm.getFormData()
      if (!getFormData) {
        return
      }
      // 获取发货方信息
      const getPickupData = await this.$refs.pickupForm.getPickupData()
      if (!getPickupData) {
        return
      }
      // 获取收货方信息
      const getReceivingData = await this.$refs.receivingForm.getReceivingData()
      if (!getReceivingData) {
        return
      }
      // 获取订单产品信息
      const getGoodsData = await this.$refs.goodsForm.getGoodsData()
      if (!getGoodsData) {
        return
      }

      // 获取订单用箱需求信息
      let getPackingData
      if (this.orderPackingDisabled) {
        getPackingData = await this.$refs.packingForm.getPackingData()
      }
      if (this.orderPackingDisabled && !getPackingData) {
        return
      }
      let getIncomeData
      if (this.contractVisible) {
        // 获取订单收入信息
        getIncomeData = await this.$refs.incomeForm.getIncomeData()
      }
      if (this.contractVisible && !getIncomeData) {
        return
      }

      // 合成订单提交参数
      let params = {
        orderStatus: val,
        ...getFormData,
        pickupPoint: getPickupData,
        receivingPoint: getReceivingData,
        ...getGoodsData,
        packingList: getPackingData,
        income: getIncomeData,
      }
      this.fullScreenLoading = true
      this.$api
        .bizOrderInfoSaveApi(params)
        .then((res) => {
          this.fullScreenLoading = false
          this.code = res.body.orderCode
          this.saveOkQuestion()
        })
        .catch(() => {
          this.fullScreenLoading = false
        })
    },
    async operatorSave(val) {
      // 获取订单主信息
      const getFormData = await this.$refs.editForm.getFormData()
      if (!getFormData) {
        return
      }
      // 获取发货方信息
      const getPickupData = await this.$refs.pickupForm.getPickupData()
      if (!getPickupData) {
        return
      }
      // 获取收货方信息
      const getReceivingData = await this.$refs.receivingForm.getReceivingData()
      if (!getReceivingData) {
        return
      }
      // 获取订单产品信息
      const getGoodsData = await this.$refs.goodsForm.getGoodsData()
      if (!getGoodsData) {
        return
      }
      // 获取订单用箱需求信息
      let getPackingData
      if (this.orderPackingDisabled) {
        getPackingData = await this.$refs.packingForm.getPackingData()
      }
      if (this.orderPackingDisabled && !getPackingData) {
        return
      }
      // 合成订单提交参数
      let params = {
        orderStatus: val,
        ...getFormData,
        pickupPoint: getPickupData,
        receivingPoint: getReceivingData,
        ...getGoodsData,
        packingList: getPackingData,
        income: {},
      }
      this.fullScreenLoading = true
      this.$api
        .bizOrderInfoSaveApi(params)
        .then((res) => {
          this.fullScreenLoading = false
          this.code = res.body.orderCode
          this.saveOkQuestion()
        })
        .catch(() => {
          this.fullScreenLoading = false
        })
    },
    saveOkQuestion() {
      // 弹出提示确认窗口
      this.dialogVisible = true
    },
    async builderNextOrder() {
      // 清空界面，创建下一张订单
      this.$refs.editForm.reset()
      this.$refs.pickupForm.reset()
      this.$refs.receivingForm.reset()
      this.$refs.goodsForm.reset()
      if (this.contractVisible) {
        this.$refs.incomeForm.reset()
      }
      if (this.orderPackingDisabled) {
        this.$refs.packingForm.reset()
      }

      this.dialogVisible = false
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
    async getTempData() {
      // 获取订单主信息
      const getFormData = await this.$refs.editForm.getFormData()
      if (!getFormData) {
        return
      }
      // 获取发货方信息
      const getPickupData = await this.$refs.pickupForm.getPickupData()
      if (!getPickupData) {
        return
      }
      // 获取收货方信息
      const getReceivingData = await this.$refs.receivingForm.getReceivingData()
      if (!getReceivingData) {
        return
      }
      // 获取订单产品信息
      const getGoodsData = await this.$refs.goodsForm.getGoodsData()
      if (!getGoodsData) {
        return
      }
      //获取订单用箱需求信息
      let getCoolerData
      if (this.orderPackingDisabled) {
        getCoolerData = await this.$refs.packingForm.getPackingData()
      }
      if (this.orderPackingDisabled && !getCoolerData) {
        return
      }
      // 合成订单提交参数
      let params = {
        ...getFormData,
        pickupPoint: getPickupData,
        receivingPoint: getReceivingData,
        ...getGoodsData,
        coolerList: getCoolerData,
      }
      return params
    },
    querySysParams() {
      this.$api
        .bizOrderPackingQueryStatusApi({ paramID: "orderPacking" })
        .then((res) => {
          this.orderPackingDisabled = res.body.flag
        })
    },
    querySysContractVisible() {
      this.$api
        .bizOrderPackingQueryStatusApi({ paramID: "contractVisible" })
        .then((res) => {
          this.contractVisible = res.body.flag
        })
    },
  },
}
</script>
